export default () => ({
  SET_ITEMS_GROUPED: (state, payload) => (state.itemsGrouped = payload)
})
